module.exports = __webpack_public_path__ + "static/media/lucas.88a79dd5.jpg";